import {
  MapExtend,
  MetaLayerDefinition,
  WMSLayerProperties,
  WMTSLayerProperties,
  scaleToResolution,
} from '@agissc/ktag-map';

export const scaleValues = [
  500, 1000, 2500, 5000, 10000, 25000, 50000, 100000, 220000, 360000,
];

export const getClosestScaleValue = (resolution: number): number =>
  scaleValues.reduce((closestScale, scaleValue) => {
    const closestDistance = Math.abs(scaleToResolution(closestScale) - resolution);
    const currentDistance = Math.abs(scaleToResolution(scaleValue) - resolution);
    return currentDistance < closestDistance ? scaleValue : closestScale;
  }, scaleValues[0]);

const getLayerProps = ({ url, type, properties, id }: MetaLayerDefinition) => {
  const serviceUrl = new URL(url);
  const layerVersion = serviceUrl.searchParams.get('version') || '';

  const getLayerMapping = (layerType: string) => {
    switch (layerType) {
      case 'wmts':
        return { layerType: 2, layerName: (properties as WMTSLayerProperties).layername };
      case 'wms':
        return { layerType: 3, layerName: (properties as WMSLayerProperties).layernames };
      default:
        return { layerType: 0, layerName: id };
    }
  };

  const { layerType, layerName } = getLayerMapping(type);
  return { layerType, layerName, layerVersion };
};

export interface MapServiceProps {
  topicLayer: MetaLayerDefinition;
  opacity: number;
  isVisible: boolean;
  layersInLegend?: number[];
  visibleLayerIds?: number[];
  isBasemap?: boolean;
}

export const getMapService = ({
  topicLayer,
  opacity,
  isVisible,
  layersInLegend = [],
  visibleLayerIds = [],
  isBasemap = false,
}: MapServiceProps) => {
  const { layerType, layerName, layerVersion } = getLayerProps(topicLayer);

  const layerUrl = isBasemap
    ? `https://www.ag.ch/geoportal/rest/services/${layerName.split('::')[0]}/MapServer`
    : topicLayer.url;

  return {
    Id: topicLayer.id,
    LayerType: isBasemap ? 1 : layerType,
    LayersInLegend: layersInLegend,
    Name: layerName,
    Opacity: opacity,
    Url: layerUrl,
    Visible: isVisible,
    VisibleLayers: visibleLayerIds,
    Version: layerVersion,
  };
};

export const getPrintExtent = (
  center: any,
  mapExtent: any,
  printWidth: number,
  printHeight: number,
): MapExtend => ({
  xMin: center.x - printWidth / 2 || mapExtent.xMin,
  yMin: center.y - printHeight / 2 || mapExtent.yMin,
  xMax: center.x + printWidth / 2 || mapExtent.xMax,
  yMax: center.y + printHeight / 2 || mapExtent.yMax,
});
